import { axiosInstance } from '../request';
export const getAgentTasks = async () => {
    const response = await axiosInstance.get('/api/v1/agent-tasks', {
        params: { limit: 100 }
    });
    return response.data.tasks;
};
export const updateAgentTask = async (data) => {
    const response = await axiosInstance.patch(`/api/v1/agent-tasks/${data.id}`, {
        prompt: data.prompt
    });
    return response.data;
};
export const deleteAgentTask = async (id) => {
    await axiosInstance.delete(`/api/v1/agent-tasks/${id}`);
};
//# sourceMappingURL=agentTasks.api.js.map